import {useDebouncedValue} from '../../../srcCommon/helpers/hookHelpers';

const SEARCH_QUERY_DEBOUNCE = 300;

export function useQueryDebounce<T extends string | undefined>(query: T): T {
  return useDebouncedValue(query, SEARCH_QUERY_DEBOUNCE);
}
